// window._ = require('lodash');
window.Popper = require("popper.js").default;
window._ = require('lodash');
window.Cookies = require('js-cookie');
// import config from "@/js/config";
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require("jquery");
  require("bootstrap");
  require("slick-carousel");
  require("jquery-nice-select/js/jquery.nice-select");
  require("jquery-bar-rating");
  require("jquery.counterup");
  require("sticky-sidebar");
  require("jquery-ui");
  // require("jquery-ui-touch-punch");
  require("lightgallery");
  require("theia-sticky-sidebar/dist/theia-sticky-sidebar");
  require("jquery-zoom");
  require("jquery.scrollto");
  // require("waypoints");
  require("owl.carousel");
  require("jquery-sticky");
  // require('slick-carousel/slick/slick.min.js');
  // require('slick-carousel/slick/slick-theme.css');
  // require('jquery-nice-select');
  // require('./assets/js/main');
  require('jquery-ui-dist/jquery-ui.min');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

// import axios from "axios";
//import router from "./router";
// import store from "./store";

// axios.defaults.baseURL = config.API_URL;
// axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Accept'] = 'application/json';
// axios.defaults.headers.post['Content-Type'] = 'application/json';
// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// axios.interceptors.request.use(config => {

//     store.dispatch("app/setLoader",{
//         isLoading: true,
//         fullPage: true,
//         canCancel: false
//     });

//     return config
// },function (error) {
//     store.dispatch("app/setLoader",{
//         isLoading: false,
//         fullPage: false,
//         canCancel: false
//     });
//     return Promise.reject(error);
// });

// axios.interceptors.response.use(function (response) {
//     store.dispatch("app/setLoader",{
//         isLoading: false,
//         fullPage: false,
//         canCancel: false
//     });
//     return response
// }, function (error) {
//     store.dispatch("app/setLoader",{
//         isLoading: false,
//         fullPage: false,
//         canCancel: false
//     });

//     if(error.response.status === 403){
//         router.push({ name: "page403"})
//     }

//     return Promise.reject(error);
// });

// window.axios = axios;

// window.Timer = 10500;

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
